import React, { useEffect, ReactNode } from 'react';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';
import useLoggedUser from '../../hooks/use-logged-user';
import { useAppContext } from './app-context';
import { ADVANCED_VIEW_ACTIVE } from '../../static/cookies';
import { IS_SB_EMAIL_LOGIN_ENABLED } from '../../static/feature-flags';
import useLinkProps from '../../hooks/use-link-props';
import LoadingIcon from '../ui/loading-icon';

const GlobalAuthGuard = ({ children }: { children: ReactNode }) => {
  const user = useLoggedUser();
  const { tenantConfig, isPSA } = useAppContext();
  const { pathname, asPath, push, locale = 'en' } = useRouter();
  const getLink = useLinkProps();
  const isRunningLocalTests = process.env.NEXT_PUBLIC_HOST?.includes('localhost');
  /**
   * O `/login` é caminho público e é para lá que um anónimo é mandado.
   *
   * ⚠️ **TEMPORÁRIO:** era só o `localhost`. A flag estende-o aos ambientes que
   * não são produção — ver `IS_SB_EMAIL_LOGIN_ENABLED`, que explica porque tem
   * de sair. A tirar, isto volta a ser o `isRunningLocalTests`.
   */
  const isEmailLoginAllowed =
    isRunningLocalTests || IS_SB_EMAIL_LOGIN_ENABLED;

  useEffect(() => {
    if (tenantConfig.id === 5) {
      if (user === null) {
        // Rotas excluídas que podem ser acedidas anonimamente
        const publicPaths = isEmailLoginAllowed ? ['/login', '/sb/error'] : ['/service-box/lg', '/sb/error'];

        // Verifica se a pathname atinge alguma das rotas de autenticação
        const isAuthRoute = publicPaths.some((p) => pathname.includes(p));

        if (!isAuthRoute) {
          if (isEmailLoginAllowed) {
            push(`/login/?redirect=${encodeURIComponent(asPath)}`);
          } else {
            push(`/sb/error`);
          }
        }
      }

      if (isPSA) {
        const restrictedPaths = ['/private-area', '/checkout'];
        const isRestrictedRoute = restrictedPaths.some((p) => pathname.startsWith(p));

        if (isRestrictedRoute) {
          push(getLink('service-box-search').href);
        }
      }
    }

    if (user !== undefined && user !== null) {
      if (!user?.staff?.is_pro && tenantConfig.id !== 5) {
        if (Cookies.get(ADVANCED_VIEW_ACTIVE) !== '0') {
          Cookies.set(ADVANCED_VIEW_ACTIVE, '0', { expires: 365 });
        }
      }
    }
  }, [user, tenantConfig.id, pathname, push, locale, getLink]);

  if (tenantConfig.id === 5) {
    const publicPaths = isEmailLoginAllowed ? ['/login', '/sb/error'] : ['/service-box/lg', '/sb/error'];
    const isAuthRoute = publicPaths.some((p) => pathname.includes(p));

    if (!isAuthRoute && (user === undefined || user === null)) {
      return <LoadingIcon />;
    }
  }

  return <>{children}</>;
};

export default GlobalAuthGuard;

